// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDY8HFWrOmVcnV3C9QzIIbC9ojRnlXfpLg",
    authDomain: "tajiruh-9a007.firebaseapp.com",
    projectId: "tajiruh-9a007",
    storageBucket: "tajiruh-9a007.appspot.com",
    messagingSenderId: "465498070570",
    appId: "1:465498070570:web:5ca9187416a85944082d53",
    measurementId: "G-FZHECX2K0Y"
  
  },
  onesignal: {
    appId: 'a525eb79-8197-4e9a-8628-3bb0735ebfb5',
    googleProjectNumber: '465498070570',
    restKey: 'MjFjYWQ1OGItNzUzZC00MWI1LWI3ZWUtMDU0NzBhNjBiNWMx'
  },
  stripe: {
    sk: ''
  },
  general: {
    symbol: '$',
    code: 'USD'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
